import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { Bookmark_QB, Question_Bookmark, Report_Submit, Result_Submit } from "../../gql/mutation";
import { GET_Instrucation_QB, Get_server_time } from "../../gql/queries";
import moment from "moment";
import { getQbProgressPercentage } from "../../utils";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
const INITIAL_STATE = {
    contentType: "",
    userFeedBack: "",
    category: "",
    contentId: ''
};
export default function QbAttempt() {
    let { id, name } = useParams()
    const navigate = useNavigate();
    const REACT_APP_ImageURL = 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    let localAttemtedQuestions = JSON.parse(localStorage.getItem(id)) ? JSON.parse(localStorage.getItem(id)) : [];   // all attempted questions
    let localstartTime = JSON.parse(localStorage.getItem('start')) ? JSON.parse(localStorage.getItem('start')) : ''; // get start time from localstorage
    let time = JSON.parse(localStorage.getItem('time')) ? JSON.parse(localStorage.getItem('time')) : 0;
    let location = useLocation();
    const [hashconfig, setHashConfig] = useState();
    const [counter, setCounter] = useState(time);
    const [showList, setShowList] = useState('list');
    const [answer, setAnswer] = useState("");
    const [dataById, setDataById] = useState({});
    const [questionAttempt, setQuestionAttempt] = useState(localAttemtedQuestions);
    const [index, setIndex] = useState(parseInt(location.state));
    const [isView, setView] = useState(questionAttempt[index] !== undefined ? true : false);
    const [infoShow, setInfo] = useState(false);
    const [qbResume, qbShow] = useState(false);
    const [imgPopup, setImgPopup] = useState(false);
    const [showImg, setShowImg] = useState();
    const [getDetails, Details] = useState(INITIAL_STATE);
    const infoDetailShow = () => setInfo(true);
    const infoDetailhide = () => setInfo(false);
    const showPopupImg = (d) => {
        setImgPopup(true);
        setShowImg(d);
    };
    const imgHide = () => setImgPopup(false);
    const qbDetailShow = () => qbShow(true);
    const qbHide = () => qbShow(false);
    const [enable, setDisabled] = useState(true)
    const [showGrid, setToggle] = useState(false);
    const toggleView = () => setToggle(true);
    const closeMobileQuesPalatte = () => setToggle(false);
    const submitQb = () => {
        resultSubmit({ variables: { resultInput: { qbId: query1.data.qb._id, resultType: "Qb", startTime: localstartTime, endTime: new Date(), duration: (moment.duration((moment(new Date())).diff(moment(localstartTime)))).asSeconds(), questions: newquestionAttempt, questionInterval: time, isCompleted: false, subjectId: query1.data.qb.subject, topicId: query1.data.qb.subjectDetail.topicId, courseName: query1.data.qb.course[0] } } })
        navigate(`/qblayer/qbinstructions/${id}/${name}`);
    }

    const TotalsubmitQb = () => {
        resultSubmit({ variables: { resultInput: { qbId: query1.data.qb._id, resultType: "Qb", startTime: localstartTime, endTime: new Date(), duration: (moment.duration((moment(new Date())).diff(moment(localstartTime)))).asSeconds(), questions: newquestionAttempt, questionInterval: time, isCompleted: true, subjectId: query1.data.qb.subject, topicId: query1.data.qb.subjectDetail.topicId, courseName: query1.data.qb.course[0] } } })
        localStorage.removeItem(id)
        navigate(`/qblayer/qbperformance/${query1.data.qb._id}/${name}`);
    }
    const showToast = (message) => {
        toast.error(message);
    };
    useEffect(() => {
        const getHashConfigData = async () => {
            try {
                const remoteData = await firebaseData('hashtag_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setHashConfig(JSON.parse(remoteData));
                // setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                // setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getHashConfigData();
        }
    }, []);
    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);

    useEffect(() => {
        const timer = schedule()
        return () => {
            if (counter == 1) {
                query1.data.qb.questions[index].options.map((d, i) => (
                    query1.data.qb.questions[index].answer[0] == d._id &&
                    selectedAnswer(query1.data.qb.questions[index].answer[0], query1.data.qb.questions[index]._id, query1.data.qb.questions[index].answer[0], i, true)
                ))
            }
            clearInterval(timer)
        };
    }, [counter])

    const schedule = () => {
        const time = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return time
    }

    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });
    const [getBookmarkQuestion] = useMutation(Question_Bookmark, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });

    const [resultSubmit] = useMutation(Result_Submit, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB, variables: {
                    "_id": id,
                }
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });

    const [report] = useMutation(Report_Submit)
    const query1 = useQuery(GET_Instrucation_QB, {
        variables: {
            "_id": id,
        },
    });

    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }

    const pre = () => {
        if (index > 0) {
            let preIndex = index - 1
            setIndex(preIndex);
            setCounter(0)
            setView(true)
        }
    }
    const next = (index) => {
        if (index < query1.data.qb.questions.length - 1) {
            if (questionAttempt[index + 1] && questionAttempt[index + 1].isAttempt == true) {
                let nextIndex = index + 1
                setIndex(nextIndex);
                setView(true)
                setCounter(0)
            }
            else {
                let nextIndex = index + 1
                setIndex(nextIndex);
                setView(false)
                setCounter(time)

            }
        }

    }
    const listView = (e) => {
        setShowList("list")
    }
    const gridView = (e) => {
        setShowList("grid")
    }
    const selectedAnswer = (answer, questionId, userAnswer, optionIndex, skipped) => {
        const data = {
            "questionId": questionId,
            "answer": answer,
            "userAnswer": skipped === true ? '' : userAnswer,
            "isReview": false,
            "isGuessed": false,
            "isAttempt": true,
            "isSkipped": skipped,
            "optionIndex": optionIndex
        }
        questionAttempt[index] = data
        setQuestionAttempt(questionAttempt)
        localStorage.setItem(id, JSON.stringify(questionAttempt));
        setView(true)
        setCounter(0)
    }
    let newquestionAttempt = []
    questionAttempt && questionAttempt != undefined && questionAttempt.map((obj, i) => {
        let data = {
            userAnswer: obj.userAnswer,
            questionId: obj.questionId
        }
        newquestionAttempt[i] = data
    })
    const copytext = async (e) => {
        navigator.clipboard.writeText(query1.data && query1.data.qb.questions[index].questionCode)
        toast.success('Copied Success')
    }

    const handleInputChange = function (fieldValue, fieldName) {
        getDetails.contentType = "Qb"
        Details({ ...getDetails, [fieldName]: fieldValue })
        if (!fieldValue) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        getDetails.contentId = query1.data && query1.data.qb.questions[index]._id
        report({ variables: { addReportInput: getDetails } }).then(res => {
            if (res.data.addUserReport.userId) {
                Details(INITIAL_STATE)
                setInfo(false)
                toast.success('Report Successful Submitted')
            }
        }).catch(res => {
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
    }

    const questionImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };

    const removeImagePlaceholders = (htmlContent) => {
        // query1.data&&query1.data.qb.questions[index].solution.solutionImage.map(obl=>{
        const modifiedHtmlContent = htmlContent.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
        // })
    };

    const questionoriginalHtml = query1.data && query1.data.qb.questions[index].question.questionText
    const questionmodifiedHtml = questionImagePlaceholders(questionoriginalHtml);

    const solutionoriginalHtml = query1.data && query1.data.qb.questions[index].solution.solutionText
    const solutionmodifiedHtml = removeImagePlaceholders(solutionoriginalHtml);
    const idValuePairs = [];
    for (const id in hashconfig) {
        if (hashconfig.hasOwnProperty(id)) {
            const value = hashconfig[id];
            idValuePairs.push({ id, value });
        }
    }
    let arrData = []
    query1.data && query1.data.qb.questions[index].tags.map(on => {
        idValuePairs.map(o => {
            if (on == o?.id) {
                // console.log(o.id)
                arrData.push(o.value)
            }

        })
    })

    const bookmarkattempt = () => {
        if (questionAttempt[index] == undefined) {
            toast.error('Please Attempt question first then bookmark your question')
        }
        else {
            getBookmarkQuestion({ variables: { status: true, qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0] } })
        }
    }
    const unbookmarkattempt = () => {
        if (questionAttempt[index] == undefined) {
            toast.error('Please Attempt question first then bookmark your question')
        }
        else {
            getBookmarkQuestion({ variables: { status: false, qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0] } })
        }
    }
    return (
        <>
            <ToastContainer />
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb mobile_attempt_crumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item"><a >QBank</a></li>
                        <li className="breadcrumb-item"><Link to={`/qblayer/qblayercontent/${query1.data.qb.parentLayerId}`}>{query1.data ? query1.data.qb.parentLayer.title : ""}</Link></li>
                        <li className="breadcrumb-item active">{query1.data ? query1.data.qb.title : ""}</li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper qbanks_wrapper section_side_padding qb_attempt_top_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="topics_wrapper_main">
                                <div className="subjects_wrapper topic_header">
                                    <div className="topic_header_content d-flex align-items-center">
                                        <div className="topic_image_ttl d-flex align-items-baseline">
                                            {/* <Link to={`/qblayer/qbinstructions/${id}`}> */}
                                            <figure className="back_arrow" onClick={qbDetailShow}>
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                            </figure>
                                            {/* </Link> */}
                                            <figure className="subject_inner_img">
                                                <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                                <span className="text_qb">QB</span>
                                            </figure>
                                            <div className="subject_ttl_detail qbanks_ttl_details">
                                                <h5>{query1.data ? query1.data.qb.title : ""}</h5>
                                                <div className="help_wrapper d-flex align-items-center">
                                                    <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{query1.data ? query1.data.qb.questions.length : 0} Questions</span></p>
                                                    {
                                                        query1.data.qb.authorDetails &&
                                                        <p><span>Verified by</span> {query1.data.qb.authorDetails ? query1.data.qb.authorDetails.name : ""}</p>
                                                    }
                                                </div>
                                                <div className="bookmarks_share">
                                                    {
                                                        query1.data && query1.data.qb.progress == null &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {
                                                        query1.data.qb.progress != null && query1.data.qb.progress.isBookMarked !== true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {
                                                        query1.data.qb.progress != null && query1.data.qb.progress.isBookMarked === true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": false } })}>
                                                            <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark QBank
                                                        </span>
                                                    }
                                                    {/* <span>
                                                    <img src={Icons.ShareBlue} alt="" className="img-fluid" /> Share QBank
                                                </span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    time != 0 && questionAttempt[index] != undefined && (questionAttempt[index].questionId !== query1.data.qb.questions[index]._id) &&
                                    <div className="recommended_video_wrapper qbanks_timer" >
                                        <div className="countdown_timer">
                                            <div className="clock_timer text-center">
                                                <img src={Icons.Timer} alt="" className="img-fluid" />
                                                {
                                                    counter < 10 &&
                                                    <span>{"00:" + "0" + counter}</span>
                                                }
                                                {
                                                    counter > 9 &&
                                                    <span>{"00:" + counter}</span>
                                                }
                                            </div>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${(100 * counter) / time}%` }}></div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    time != 0 && questionAttempt[index] === undefined &&
                                    <div className="recommended_video_wrapper qbanks_timer" >
                                        <div className="countdown_timer">
                                            <>
                                                <div className="clock_timer text-center">
                                                    <img src={Icons.Timer} alt="" className="img-fluid" />
                                                    {
                                                        counter < 10 &&
                                                        <span>{"00:" + "0" + counter}</span>
                                                    }
                                                    {
                                                        counter > 9 &&
                                                        <span>{"00:" + counter}</span>
                                                    }
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar" style={{ width: `${(100 * counter) / time}%` }}></div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                }
                                <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                    <div className="instruction_header d-flex align-items-center">
                                        <div className="attempt_ttl">
                                            <h6>Question {index + 1}<span> out of {query1.data && query1.data.qb.questions != null ? query1.data.qb.questions.length : 0}</span></h6>
                                        </div>
                                        <div className="ttl_options">
                                            {/* <span>
                                            <img src={Icons.ShareBlue} alt="share" className="img-fluid" />
                                        </span> */}
                                            <span onClick={infoDetailShow}>
                                                <img src={Icons.Info} alt="share" className="img-fluid" />
                                            </span>
                                            {
                                                query1.data && query1.data.qb.progress == null &&
                                                <span onClick={() => bookmarkattempt()}>
                                                    <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                </span>
                                                // <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0] } })}>
                                                //     <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                // </span>
                                            }
                                            {
                                                query1.data && query1.data.qb.progress != null && !query1.data.qb.progress.bookmarkedQids.includes(query1.data.qb.questions[index]._id) &&
                                                <span onClick={() => bookmarkattempt()}>
                                                    <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                </span>
                                                // <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0] } })}>
                                                //     <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                // </span>
                                            }
                                            {
                                                query1.data.qb.progress != null && query1.data.qb.progress.bookmarkedQids.includes(query1.data.qb.questions[index]._id) &&
                                                <span onClick={() => unbookmarkattempt()}>
                                                    <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                                </span>
                                                // <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0] } })}>
                                                //     <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                                // </span>
                                            }

                                            {/* <span onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: query1.data.qb.questions[index]._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                            <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                        </span> */}
                                        </div>
                                    </div>
                                    <div className="instructions_details">
                                        <div className="questions_ttl">

                                            <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                            <div className="ans_img_wrapper">
                                                {
                                                    query1?.data?.qb && query1?.data?.qb?.questions[index]?.question?.questionImage[0] &&
                                                    <img src={query1?.data?.qb?.questions[index]?.question?.questionImage[0].includes('/') ? query1?.data?.qb?.questions[index]?.question?.questionImage[0] : REACT_APP_ImageURL + query1?.data?.qb?.questions[index]?.question?.questionImage[0]} alt="" className="img-fluid" />
                                                }
                                                {
                                                    query1?.data?.qb && query1?.data?.qb?.questions[index]?.question?.questionImage[0] &&
                                                    <figcaption className="img_fullscreen" onClick={() => showPopupImg(query1?.data?.qb?.questions[index]?.question?.questionImage[0]?.includes('/') ? query1?.data?.qb?.questions[index]?.question?.questionImage[0] : REACT_APP_ImageURL + query1?.data?.qb?.questions[index]?.question?.questionImage[0])}>
                                                        <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                    </figcaption>
                                                }
                                                {/* {
                                                query1.data.qb.questions[index].question.questionImage[0] &&
                                                <div className="ans_img_wrapper">
                                                    <img src={query1.data.qb ? query1.data.qb.questions[index].question.questionImage[0] : Images.AnsImg} alt="" className="img-fluid" />
                                                    <figcaption className="img_fullscreen" onClick={() => showPopupImg(query1.data.qb.questions[index].question.questionImage[0])}>
                                                        <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                    </figcaption>
                                                </div>
                                            } */}
                                            </div>
                                        </div>
                                        <ul type="none" className="instruction_list">
                                            {
                                                isView == false &&
                                                query1.data.qb.questions[index].options && query1.data.qb.questions[index].options.map((d, i) => (
                                                    <li>
                                                        <div className="ins_list_content d-flex align-items-center" onClick={() => selectedAnswer(query1.data.qb.questions[index].answer[0], query1.data.qb.questions[index]._id, d._id, i, false)}>
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>

                                                            </div>
                                                            {/* {
                                                        isView == true &&
                                                        <div className="ques_percent">
                                                            <span>{query1.data.qb.questions[index] ? Math.round((d.optionAttempt*100) / query1.data.qb.questions[index].totalAttemptCount) : 0}%</span>
                                                        </div>
                                                        } */}
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                            {
                                                isView == true &&
                                                query1.data.qb.questions[index].options && query1.data.qb.questions[index].options.map((d, i) => (
                                                    <li className={((d._id == ((questionAttempt[index] && questionAttempt[index].userAnswer) ? questionAttempt[index]?.userAnswer : "")) ? (questionAttempt[index] && questionAttempt[index].answer) == ((questionAttempt[index] && questionAttempt[index]?.userAnswer) ? questionAttempt[index]?.userAnswer : "") ? 'correct' : 'wrong' : (questionAttempt[index] && questionAttempt[index].answer) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center">
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>

                                                            </div>
                                                            {/* {
                                                        isView == true &&
                                                        <div className="ques_percent">
                                                            <span>{query1.data.qb.questions[index] ? Math.round((d.optionAttempt*100) / query1.data.qb.questions[index].totalAttemptCount)>0?Math.round((d.optionAttempt*100) / query1.data.qb.questions[index].totalAttemptCount):0 : 0}%</span>
                                                        </div>
                                                        } */}
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                            {/* <li className='correct'>
                                            <div className="ins_list_content d-flex align-items-center">
                                                <div className="ques_attempt_body">
                                                    <div className="inst_counts">
                                                        <span>B</span>
                                                    </div>
                                                    <div className="ins_texts">
                                                        <p>Lesion to spinal root of accessory nerve</p>
                                                    </div>
                                                </div>
                                                <div className="ques_percent">
                                                    <span>82%</span>
                                                </div>
                                            </div>  
                                        </li>
                                        <li className="wrong">
                                            <div className="ins_list_content d-flex align-items-center">
                                                <div className="ques_attempt_body">
                                                    <div className="inst_counts">
                                                        <span>C</span>
                                                    </div>
                                                    <div className="isrcns_texts">
                                                        <p>Lesion to spinal root of accessory nerve</p>
                                                    </div>
                                                </div>
                                                <div className="ques_percent">
                                                    <span>82%</span>
                                                </div>
                                            </div>  
                                        </li>
                                        <li>
                                            <div className="ins_list_content d-flex align-items-center">
                                                <div className="ques_attempt_body">
                                                    <div className="inst_counts">
                                                        <span>D</span>
                                                    </div>
                                                    <div className="ins_texts">
                                                        <p>Lesion to spinal root of accessory nerve</p>
                                                    </div>
                                                </div>
                                                <div className="ques_percent">
                                                    <span>82%</span>
                                                </div>
                                            </div> 
                                        </li> */}

                                        </ul>
                                        {/* {
                                        isView == true &&
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(query1.data.qb.questions[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(query1.data.qb.questions[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                    </div>
                                </div>
                                {
                                    isView == true &&
                                    <>
                                        <div className="recommended_video_wrapper answer_details_wrapper">
                                            {
                                                query1.data.qb.questions[index].options.map((d, i) => (
                                                    query1.data.qb.questions[index].answer[0] == d._id &&
                                                    <>
                                                        <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                        <h6>{query1.data.qb.questions[index].answer[0] == d._id ? d.optionText : ''}</h6>
                                                    </>
                                                ))
                                            }
                                            <div className="ans_tags">
                                                {
                                                    arrData.map(i => (
                                                        <span>#{i}</span>
                                                    ))
                                                }
                                            </div>
                                            <div className="editor_data">
                                                <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                            </div>
                                            {
                                                query1.data?.qb?.questions[index]?.solution?.solutionImage?.map((o) => (
                                                    <>
                                                        <div className="ans_img_wrapper">
                                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                                            <figcaption className="img_fullscreen" onClick={() => showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                            </figcaption>
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </div>
                                        {
                                            query1.data.qb.questions[index].elements.length != 0 &&
                                            <>
                                                {
                                                    query1.data.qb.questions[index].elements.map((d, i) => (
                                                        <>
                                                            {
                                                                d.type == "highyeild" &&
                                                                <div className="high_yield_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#HighYield</h6>
                                                                        </div>
                                                                        <div className="highyield_content" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                        {/* <p>Lörem ipsum decinera. Bårade kar nong degt då monovis rasm. Multirar dosk tritis, barista. Pyfunar infrasat povis plavis. Tinde digument i epid, såväl som heterov ajorad. Egon bevis ett ruliga begasoling inklusive koska så elig. Kinat here:Kalsongbadare bånt, kompetensutvisning paratågt. Täning rugt, kinar, vatt. Hypogen kont för att absiv och dell, epitärade nyre.Kogujener mipybonera, rihölig om kakande. Exogen stenont ranyligen teranade om hevåren. </p> */}
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                d.type == 'extraedge' &&
                                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="extraEdge_ttl">
                                                                            <h6>#ExtraEdge</h6>
                                                                        </div>
                                                                        <div className="extraedge_content" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                        {/* <p>Lörem ipsum decinera. Bårade kar nong degt då monovis rasm. Multirar dosk tritis, barista. Pyfunar infrasat povis plavis. Tinde digument i epid, såväl som heterov ajorad. Egon bevis ett ruliga begasoling inklusive koska så elig. Kinat here:Kalsongbadare bånt, kompetensutvisning paratågt. Täning rugt, kinar, vatt. Hypogen kont för att absiv och dell, epitärade nyre.Kogujener mipybonera, rihölig om kakande. Exogen stenont ranyligen teranade om hevåren. </p> */}
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                d.type == 'table' &&
                                                                <div className="high_yield_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#Table</h6>
                                                                        </div>
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                        {/* <p>Lörem ipsum decinera. Bårade kar nong degt då monovis rasm. Multirar dosk tritis, barista. Pyfunar infrasat povis plavis. Tinde digument i epid, såväl som heterov ajorad. Egon bevis ett ruliga begasoling inklusive koska så elig. Kinat here:Kalsongbadare bånt, kompetensutvisning paratågt. Täning rugt, kinar, vatt. Hypogen kont för att absiv och dell, epitärade nyre.Kogujener mipybonera, rihölig om kakande. Exogen stenont ranyligen teranade om hevåren. </p> */}
                                                                    </div>
                                                                </div>
                                                                // <div className="high_yield_wrapper mantra_table_wrapper">
                                                                //     <div className="extraEdge_ttl">
                                                                //         <h6>#Mantra</h6>
                                                                //     </div>
                                                                //     <div className="table_wrapper">
                                                                //         <div className="table-responsive">
                                                                //             <table className="table table-bordered">
                                                                //                 <tbody>
                                                                //                     <tr>
                                                                //                         <td>Inborn error of metabolism</td>
                                                                //                         <td>Urine odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Phenlketonuria</td>
                                                                //                         <td>Mousy odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Maple syrup urine disease</td>
                                                                //                         <td>Maple syrup urine disease</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Multiple Carboxylase deficiency</td>
                                                                //                         <td>Tomcat urine odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Hawkinsinuria</td>
                                                                //                         <td>Swimming pool odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Isovaleric acidemia</td>
                                                                //                         <td>Sweaty feet odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Glutaric acidemia  (Type II)</td>
                                                                //                         <td>Sweaty feet odour</td>
                                                                //                     </tr>
                                                                //                 </tbody>
                                                                //             </table>
                                                                //         </div>
                                                                //     </div>
                                                                // </div>
                                                            }
                                                            {
                                                                d.type == 'random' &&
                                                                <div className="high_yield_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#Random</h6>
                                                                        </div>
                                                                        <div className="random_content" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                        {/* <p>Lörem ipsum decinera. Bårade kar nong degt då monovis rasm. Multirar dosk tritis, barista. Pyfunar infrasat povis plavis. Tinde digument i epid, såväl som heterov ajorad. Egon bevis ett ruliga begasoling inklusive koska så elig. Kinat here:Kalsongbadare bånt, kompetensutvisning paratågt. Täning rugt, kinar, vatt. Hypogen kont för att absiv och dell, epitärade nyre.Kogujener mipybonera, rihölig om kakande. Exogen stenont ranyligen teranade om hevåren. </p> */}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    ))
                                                }
                                            </>
                                        }
                                        
                                        {
                                            query1.data.qb.questions[index]?.pearls?.length != 0 &&
                                            <>
                                                {
                                                    query1.data.qb.questions[index]?.pearls?.map((d, i) => (
                                                        <>

                                                            {
                                                                <div className="high_yield_wrapper ">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl d-flex">
                                                                            <h6>#Mantra</h6>
                                                                            <div className="qid_code text-center"  >
                                                                            <ToastContainer />
                                                                            <span  >{d?.pearlsCode}</span>
                                                                            <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => copytext()} />
                                                                        </div>
                                                                        </div>
                                                                       
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.description : ""}` }}></div>
                                                                    </div>
                                                                </div>
                                                                // <div className="high_yield_wrapper mantra_table_wrapper">
                                                                //     <div className="extraEdge_ttl">
                                                                //         <h6>#Mantra</h6>
                                                                //     </div>
                                                                //     <div className="table_wrapper">
                                                                //         <div className="table-responsive">
                                                                //             <table className="table table-bordered">
                                                                //                 <tbody>
                                                                //                     <tr>
                                                                //                         <td>Inborn error of metabolism</td>
                                                                //                         <td>Urine odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Phenlketonuria</td>
                                                                //                         <td>Mousy odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Maple syrup urine disease</td>
                                                                //                         <td>Maple syrup urine disease</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Multiple Carboxylase deficiency</td>
                                                                //                         <td>Tomcat urine odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Hawkinsinuria</td>
                                                                //                         <td>Swimming pool odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Isovaleric acidemia</td>
                                                                //                         <td>Sweaty feet odour</td>
                                                                //                     </tr>
                                                                //                     <tr>
                                                                //                         <td>Glutaric acidemia  (Type II)</td>
                                                                //                         <td>Sweaty feet odour</td>
                                                                //                     </tr>
                                                                //                 </tbody>
                                                                //             </table>
                                                                //         </div>
                                                                //     </div>
                                                                // </div>
                                                            }
                                                        </>
                                                    ))
                                                }
                                            </>
                                        }
                                        <div className="recommended_video_wrapper qid_wrapper">
                                            <h5>Reference</h5>
                                            <p>{query1.data.qb.questions[index].reference}</p>
                                        </div>
                                        <div className="recommended_video_wrapper qid_wrapper qid_code_wrapper d-flex align-items-center">
                                            <div className="qid_ttl">
                                                <h6>QID:</h6>
                                            </div>
                                            <div className="qid_code text-center"  >
                                                <ToastContainer />
                                                <span  >{query1.data.qb.questions[index].questionCode}</span>
                                                <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => copytext()} />
                                            </div>
                                        </div>
                                    </>
                                }
                                <span className="toggle_view" onClick={toggleView}>
                                    <img src={Icons.ListGridToggle} alt="" className="img-fluid" />
                                </span>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-5 col-sm-12">
                            <div className="videos_wrapper">
                                {
                                    time != 0 && questionAttempt[index] != undefined && (questionAttempt[index].questionId !== query1.data.qb.questions[index]._id) &&
                                    <div className="recommended_video_wrapper hide_timer">
                                        <div className="countdown_timer">
                                            <>
                                                <div className="clock_timer text-center">
                                                    <img src={Icons.Timer} alt="" className="img-fluid" />
                                                    {
                                                        counter < 10 &&
                                                        <span>{"00:" + "0" + counter}</span>
                                                    }
                                                    {
                                                        counter > 9 &&
                                                        <span>{"00:" + counter}</span>
                                                    }
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar" style={{ width: `${(100 * counter) / time}%` }}></div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                }
                                {
                                    time != 0 && questionAttempt[index] === undefined &&
                                    <div className="recommended_video_wrapper hide_timer">
                                        <div className="countdown_timer">
                                            <>
                                                <div className="clock_timer text-center">
                                                    <img src={Icons.Timer} alt="" className="img-fluid" />
                                                    {
                                                        counter < 10 &&
                                                        <span>{"00:" + "0" + counter}</span>
                                                    }
                                                    {
                                                        counter > 9 &&
                                                        <span>{"00:" + counter}</span>
                                                    }
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar" style={{ width: `${(100 * counter) / time}%` }}></div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                }
                                <div className="recommended_video_wrapper hide_web_toggle_view">
                                    <div className="all_questions_wrapper">
                                        <div className="all_question_ttl">
                                            <h6>All Questions</h6>
                                            <p>{query1.data && query1.data.qb.title}</p>
                                        </div>
                                        <div className="questions_indicators d-flex align-items-center flex-wrap">
                                            <div className="questions_options_indicators d-flex flex-wrap">
                                                <p className="correct"><span></span>Correct</p>
                                                <p className="incorrect"><span></span>Incorrect</p>
                                                <p className="unanswered"><span></span>Unanswered</p>
                                                <p className="skipped"><span></span>Unattempted</p>
                                            </div>
                                            <div className="choose_views">
                                                <span className={`list_view ${showList === 'list' ? 'colored' : ''}`} onClick={(e) => listView(e)}>
                                                    <img src={Icons.ListView} alt="" className="img-fluid" />
                                                </span>
                                                <span className={`grid_view ${showList !== 'list' ? 'colored' : ''}`} onClick={(e) => gridView(e)}>
                                                    <img src={Icons.GridView} alt="" className="img-fluid" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="all_questions_listings">
                                            {
                                                showList == 'list' &&
                                                <ul type="none" className="questions_list_child">
                                                    {/* {
                                                            query1.data.qb.questions.map((d, i) => (
                                                                <li onClick={(e) => next(i - 1)}>
                                                                    <div className="question_body d-flex align-items-center">
                                                                        <div className="question_body_details d-flex align-items-center">
                                                                            <figure className="user_img skipped">
                                                                                <span className="bookarks_qb">Q{i + 1}</span>
                                                                            </figure>
                                                                            <div className="continue_qbanks_wrapper">
                                                                                <h6>{d.question.questionText}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))

                                                        } */}
                                                    {
                                                        query1.data && query1.data.qb.questions.map((d, i) => (
                                                            questionAttempt[i] && questionAttempt[i].isAttempt == true &&
                                                            <li onClick={(e) => next(i - 1)}>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className={`user_img ${((questionAttempt[i] && questionAttempt[i]?.userAnswer) == (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true) ? 'correct' : ((questionAttempt[i] && questionAttempt[i].userAnswer) != (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true)) ? 'incorrect' : 'unanswered')}`}>
                                                                            <span className="bookarks_qb">Q{i + 1}</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>{d.question.questionText}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {
                                                        query1.data && query1.data.qb.questions.map((d, i) => (
                                                            questionAttempt[i] == undefined &&
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img skipped">
                                                                            <span className="bookarks_qb">Q{i + 1}</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>{d.question.questionText}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {/* <li>
                                                        <div className="question_body d-flex align-items-center">
                                                            <div className="question_body_details d-flex align-items-center">
                                                                <figure className="user_img incorrect">
                                                                    <span className="bookarks_qb">Q2</span>
                                                                </figure>
                                                                <div className="continue_qbanks_wrapper">
                                                                    <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img correct">
                                                                            <span className="bookarks_qb">Q3</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img unanswered">
                                                                            <span className="bookarks_qb">Q4</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img skipped">
                                                                            <span className="bookarks_qb">Q5</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img">
                                                                            <span className="bookarks_qb">Q6</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img">
                                                                            <span className="bookarks_qb">Q7</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="rightArrow_icn">
                                                                <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                            </div>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            }
                                            {
                                                showList == 'grid' &&
                                                <ul type="none" className="questions_list_child grid_view d-flex flex-wrap">
                                                    {
                                                        query1.data && query1.data.qb.questions.map((d, i) => (
                                                            questionAttempt[i] && questionAttempt[i].isAttempt == true &&
                                                            <li onClick={(e) => next(i - 1)}><span className={((questionAttempt[i] && questionAttempt[i].userAnswer) == (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true) ? 'correct' : ((questionAttempt[i] && questionAttempt[i].userAnswer) != (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true)) ? 'incorrect' : 'unanswered')}>Q{i + 1}</span></li>
                                                        )
                                                        )


                                                    }
                                                    {
                                                        query1.data && query1.data.qb.questions.map((d, i) => (
                                                            questionAttempt[i] == undefined &&
                                                            <li><span className='skipped'>Q{i + 1}</span></li>
                                                        )
                                                        )
                                                    }
                                                    {/* <li><span>Q2</span></li>
                                                    <li><span>Q3</span></li>
                                                    <li><span>Q4</span></li>
                                                    <li><span>Q5</span></li>
                                                    <li><span>Q6</span></li>
                                                    <li><span>Q7</span></li>
                                                    <li><span>Q8</span></li>
                                                    <li><span>Q9</span></li>
                                                    <li><span>Q10</span></li>
                                                    <li><span>Q11</span></li>
                                                    <li><span>Q12</span></li>
                                                    <li><span>Q13</span></li>
                                                    <li><span>Q14</span></li>
                                                    <li><span>Q15</span></li> */}
                                                </ul>
                                            }

                                        </div>
                                    </div>
                                </div>
                                {showGrid !== false &&
                                    <div className={`recommended_video_wrapper ${showGrid == false ? "hide_toggled_view" : "mobile_toggled_view"}`}>
                                        <div className="all_questions_wrapper">
                                            <div className="mobile_view_ques_number d-flex justify-content-between">
                                                <div className="all_question_ttl">
                                                    <h6>All Questions</h6>
                                                    <p>{query1.data && query1.data.qb.title}</p>
                                                </div>
                                                <span className="cross_img" onClick={closeMobileQuesPalatte}>
                                                    <img src={Icons.ModalCross} alt="" className="img-fluid" />
                                                </span>
                                            </div>
                                            <div className="questions_indicators d-flex align-items-center flex-wrap">
                                                <div className="questions_options_indicators d-flex flex-wrap">
                                                    <p className="correct"><span></span>Correct</p>
                                                    <p className="incorrect"><span></span>Incorrect</p>
                                                    <p className="unanswered"><span></span>Unanswered</p>
                                                    <p className="skipped"><span></span>Unattempted</p>
                                                </div>
                                                <div className="choose_views">
                                                    <span className={`list_view ${showList === 'list' ? 'colored' : ''}`} onClick={(e) => listView(e)}>
                                                        <img src={Icons.ListView} alt="" className="img-fluid" />
                                                    </span>
                                                    <span className={`grid_view ${showList !== 'list' ? 'colored' : ''}`} onClick={(e) => gridView(e)}>
                                                        <img src={Icons.GridView} alt="" className="img-fluid" />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="all_questions_listings">
                                                {
                                                    showList == 'list' &&
                                                    <ul type="none" className="questions_list_child">
                                                        {/* {
                                                            query1.data.qb.questions.map((d, i) => (
                                                                <li onClick={(e) => next(i - 1)}>
                                                                    <div className="question_body d-flex align-items-center">
                                                                        <div className="question_body_details d-flex align-items-center">
                                                                            <figure className="user_img skipped">
                                                                                <span className="bookarks_qb">Q{i + 1}</span>
                                                                            </figure>
                                                                            <div className="continue_qbanks_wrapper">
                                                                                <h6>{d.question.questionText}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))

                                                        } */}
                                                        {
                                                            query1.data && query1.data.qb.questions.map((d, i) => (
                                                                questionAttempt[i] && questionAttempt[i].isAttempt == true &&
                                                                <li onClick={(e) => next(i - 1)}>
                                                                    <div className="question_body d-flex align-items-center">
                                                                        <div className="question_body_details d-flex align-items-center">
                                                                            <figure className={`user_img ${((questionAttempt[i] && questionAttempt[i].userAnswer) == (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true) ? 'correct' : ((questionAttempt[i] && questionAttempt[i].userAnswer) != (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true)) ? 'incorrect' : 'unanswered')}`}>
                                                                                <span className="bookarks_qb">Q{i + 1}</span>
                                                                            </figure>
                                                                            <div className="continue_qbanks_wrapper">
                                                                                <h6>{d.question.questionText}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))
                                                        }
                                                        {
                                                            query1.data && query1.data.qb.questions.map((d, i) => (
                                                                questionAttempt[i] == undefined &&
                                                                <li>
                                                                    <div className="question_body d-flex align-items-center">
                                                                        <div className="question_body_details d-flex align-items-center">
                                                                            <figure className="user_img skipped">
                                                                                <span className="bookarks_qb">Q{i + 1}</span>
                                                                            </figure>
                                                                            <div className="continue_qbanks_wrapper">
                                                                                <h6>{d.question.questionText}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightArrow_icn">
                                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))
                                                        }
                                                        {/* <li>
                                                        <div className="question_body d-flex align-items-center">
                                                            <div className="question_body_details d-flex align-items-center">
                                                                <figure className="user_img incorrect">
                                                                    <span className="bookarks_qb">Q2</span>
                                                                </figure>
                                                                <div className="continue_qbanks_wrapper">
                                                                    <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img correct">
                                                                            <span className="bookarks_qb">Q3</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className="user_img">
                                                                            <span className="bookarks_qb">Q7</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="rightArrow_icn">
                                                                        <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="rightArrow_icn">
                                                                <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                            </div>
                                                        </div>
                                                    </li> */}
                                                    </ul>
                                                }
                                                {
                                                    showList == 'grid' &&
                                                    <ul type="none" className="questions_list_child grid_view d-flex flex-wrap">
                                                        {
                                                            query1.data && query1.data.qb.questions.map((d, i) => (
                                                                questionAttempt[i] && questionAttempt[i].isAttempt == true &&
                                                                <li onClick={(e) => next(i - 1)}><span className={((questionAttempt[i] && questionAttempt[i].userAnswer) == (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true) ? 'correct' : ((questionAttempt[i] && questionAttempt[i].userAnswer) != (questionAttempt[i] && questionAttempt[i].answer) && (questionAttempt[i] && questionAttempt[i].isSkipped != true)) ? 'incorrect' : 'unanswered')}>Q{i + 1}</span></li>
                                                            )
                                                            )


                                                        }
                                                        {
                                                            query1.data && query1.data.qb.questions.map((d, i) => (
                                                                questionAttempt[i] == undefined &&
                                                                <li><span className='skipped'>Q{i + 1}</span></li>
                                                            )
                                                            )
                                                        }
                                                        {/* <li><span>Q2</span></li>
                                                    <li><span>Q3</span></li>
                                                    <li><span>Q4</span></li>
                                                    <li><span>Q5</span></li>
                                                    <li><span>Q6</span></li>
                                                    <li><span>Q7</span></li>
                                                    <li><span>Q8</span></li>
                                                    <li><span>Q9</span></li>
                                                    <li><span>Q10</span></li>
                                                    <li><span>Q11</span></li>
                                                    <li><span>Q12</span></li>
                                                    <li><span>Q13</span></li>
                                                    <li><span>Q14</span></li>
                                                    <li><span>Q15</span></li> */}
                                                    </ul>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="nexts_prevs_buttons">
                                    {
                                        isView == true &&
                                        <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                    }
                                    {
                                        (isView == true && index < query1.data.qb.questions.length - 1) &&
                                        <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                    }
                                    {
                                        isView == true && index == query1.data.qb.questions.length - 1 &&
                                        <button type="button" className="btn btn_theme btn_next" onClick={TotalsubmitQb}>Submit</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Modal
                show={infoShow}
                onHide={infoDetailhide}
                backdrop="static"
                className="detail_modal report_modal"
                centered
            >
                <ToastContainer />
                <form action="" onSubmit={(e) => { handleSubmit(e) }}>
                    <Modal.Header>
                        <Modal.Title>
                            <h4>Report Issue</h4>
                            <span className="cross_icon">
                                <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={infoDetailhide} />
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="rating_modal_body">
                            <div className="form-group">
                                <label htmlFor="">Issue Type</label>
                                <select name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'category')} value={getDetails.category ?? ''}>
                                    <option value=''>Please Select</option>
                                    {
                                        config && config?.qb_question?.categories?.map((d, i) => (
                                            <option value={d.category_name}>{d.category_name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Description</label>
                                <textarea name="" id="" rows="5" className="form-control" placeholder="Please add issue description here..." onChange={(e) => handleInputChange(e.target.value, 'userFeedBack')} value={getDetails.userFeedBack}></textarea>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="rating_submit">
                            <button type="button" className="btn btn_theme btn_border" onClick={infoDetailhide}>Cancel</button>
                            <button type="submit" disabled={enable} className="btn btn_theme" >Submit</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={qbResume}
                onHide={qbHide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this QB?</h5>
                        <p>You can anytime come back and continue from where you left.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={qbHide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={submitQb}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={imgPopup}
                onHide={imgHide}
                backdrop="static"
                className="detail_modal modelImgPopup"
                centered
                size="lg"
            >
                <Modal.Body>
                    <div className="Img_wrapper">
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={imgHide} />
                        </span>
                        <div className="img_popup">
                            <img src={showImg} alt="Popup Image" />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}